<template>
	<div class="callback-page">
		<div class="loading-box">
			<div class="spinner"></div>
			<p>正在处理登录请求...</p>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import eventBus from '@/utils/eventBus'
	import {
		ElMessage
	} from 'element-plus'
	import 'element-plus/es/components/message/style/css'

	export default {
		name: 'WechatCallback',
		created() {
			const code = this.$route.query.code
			const state = this.$route.query.state
			if (code) {
				this.handleWechatCallback(code, state)
			} else {
				this.$message.error('参数错误')
				this.$router.replace('/')
			}
		},
		methods: {
			async handleWechatCallback(code, state) {
				try {
					const res = await request.get('/api/user/callback', {
						params: {
							code,
							state
						}
					})

					// 业务 code=402 表示微信扫码登录成功但账号未注册，需要跳转到注册页
					// 这里 data 可能是 res 本身（如果 request.js 中返回了 res）或者 res.data
					const bizCode = res && res.code
					
					if (bizCode === 402) {
						// 尝试从多种结构中获取 pcOpenid / unionid
						// 如果 res 是 { code: 402, msg: '...', data: { pcOpenid: '...' } }
						const data = res.data || res
						const pcOpenid = data && (data.pcOpenid || data.pc_openid)
						const unionid = data && data.unionid

						this.$router.replace({
							path: '/register',
							query: {
								pcOpenid: pcOpenid || '',
								unionid: unionid || ''
							}
						})
						return
					}

					if (res && res.token) {
						// 登录成功
						localStorage.setItem('token', res.token)
						if (res.userInfo) {
							localStorage.setItem('userInfo', JSON.stringify(res.userInfo))
						}
						ElMessage.success('登录成功')
						eventBus.emit('login-success')
						this.$router.replace('/')
					}
				} catch (error) {
					console.error('Callback error:', error)
					// 假设拦截器 reject 的 error 对象包含 response 信息
					// 或者后端返回 200 但 code=402

					// 如果拦截器已经处理了，我们需要确认拦截器的行为
					// 假设拦截器 reject 了，我们需要判断错误码

					if (error.code === 402 || (error.response && error.response.data && error.response.data.code ===
							402)) {
						// 兜底处理：如果拦截器把 402 当成错误抛出，则在这里也做一次跳注册页
						const data = (error.response && error.response.data && error.response.data.data) || error.data
						const pcOpenid = data && (data.pcOpenid || data.pc_openid)
						const unionid = data && data.unionid
						this.$router.replace({
							path: '/register',
							query: {
								pcOpenid: pcOpenid || '',
								unionid: unionid || ''
							}
						})
					} else {
						ElMessage.error(error.message || '登录失败，请重试')
						this.$router.replace('/')
					}
				}
			}
		}
	}
</script>

<style scoped>
	.callback-page {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background-color: #f5f5f5;
	}

	.loading-box {
		text-align: center;
	}

	.spinner {
		border: 4px solid rgba(0, 0, 0, 0.1);
		width: 36px;
		height: 36px;
		border-radius: 50%;
		border-left-color: #ff9900;
		animation: spin 1s linear infinite;
		margin: 0 auto 20px;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}
</style>